// services/submissions.js
import { DRAFT_END_URL } from '../constants/all'
import { getMethod } from '../utils/api'

export const fetchFilterTabs = () => getMethod({ url: '/submissions/submissions/v2/filters' })

export const fetchSubmissions = ({ statusIds = [], cursor = null, limit = 10 } = {}) =>
  getMethod({
    url: '/submissions/submissions/',
    params: {
      ...(statusIds.length && { status: statusIds }),
      ...(cursor && { cursor }),
      limit
    }
  })

export const fetchContextData = async ({ cookie, setFormContext, isEnterprise = false }) => {
  const language = cookie.get('language') || 'en'
  const location = cookie.get('location')
  const userState = cookie.get('userState')

  const params = {
    location_id: location?.id,
    en: 0
  }
  if (userState) params.state_id = userState
  if (isEnterprise) params.submission_type = 'enterprise'

  /** ----------------------------------------------------------------
   *  New helper already has       baseURL = NEXT_PUBLIC_BASE_URL_ADS
   *  so we pass ONLY the path.  Case-correct “withStatusCode”.
   * ----------------------------------------------------------------*/
  const res = await getMethod({
    url: DRAFT_END_URL, // e.g. '/submissions/submissions/draft_context/'
    params,
    headers: {
      'Accept-Language': language
    },
    withStatusCode: true
  })

  const data = res?.data ? { ...res.data } : {}
  setFormContext(data?.context || {})
}
